module.exports = __webpack_public_path__ + "static/logo_text-182ecd96a5363d7cb79c08f8ed803e18.png";